import { render } from "./Activate.vue?vue&type=template&id=37249a05&scoped=true"
import script from "./Activate.vue?vue&type=script&lang=js"
export * from "./Activate.vue?vue&type=script&lang=js"

import "./custom-activate.scss?vue&type=style&index=0&id=37249a05&lang=scss&scoped=true"
import "./Activate.vue?vue&type=style&index=1&id=37249a05&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37249a05"]])

export default __exports__